import { Component } from '@angular/core';
import { UtilService } from '../../shared/services/util.service';
import { ExcelService } from '../../shared/services/excel.service';
import { ApiService } from '../../shared/services/api.service';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-reconciliation',
  templateUrl: './reconciliation.component.html',
  standalone: false,
  styleUrls: ['./reconciliation.component.scss']
})
export class ReconciliationComponent {

    placeHolder = 'DD/MM/YYYY';
  minStart: any;
  fromDate: any = null;
  toDate: any = null;
  type: any;
  excelData: any;
  excelFile: any;
  reconciliationData: any;

  constructor(private _util: UtilService,
    private _excel: ExcelService,
    private _apiService: ApiService,
    private _auth: AuthService
  ) {

  }

  onFromDate(event: any) {
    const vm = this;
    vm.minStart = vm._util.getMinFormat(event);
  }


  uploadExcel(event: any) {
    const vm = this;
    const file = event.target.files[0];
    vm.excelFile = file;
    // vm._excel.readExcel(event, data => {
    //   if (data && Array.isArray(data) && data.length > 0) {
    //     vm.excelData = data;
    //     console.log('Excel data:', data);
    //   }
    // });
  }

    onClear() {
    const vm = this;
    vm.fromDate = null;
    vm.toDate = null;
    vm.type = null;
    vm.excelData = null;
    vm.excelFile = null;
    vm.minStart = null;
    vm.reconciliationData = null;
  }

  onSubmit() {
    const vm = this;
    if (!vm.fromDate || !vm.toDate || !vm.type || !vm.excelFile) {
      return;
    }

    const user = vm._auth.getUser();
      if (!user || !user.partnerId || !user.partnerId._id) {
      return;
    }

    // Convert ngbDatepicker date objects to timestamps
    const startDate = new Date(vm.fromDate.year, vm.fromDate.month - 1, vm.fromDate.day).getTime();
    const endDate = new Date(vm.toDate.year, vm.toDate.month - 1, vm.toDate.day, 23, 59, 59, 999).getTime();

    const formData = new FormData();
    formData.append('startDate', startDate.toString());
    formData.append('endDate', endDate.toString());
    formData.append('type', vm.type);
    formData.append('file', vm.excelFile, vm.excelFile.name || 'ledger.xlsx');
    
    const apiUrl = '/partners/auth/excel-reconciliation';
    vm._apiService.postData(apiUrl, formData).subscribe((res: any) => {
      if (res && !res.error) {
        vm.reconciliationData = res.data;
      }
    });
  }

}
